<template>
  <div class="ConstructionTeamDetail_page" v-loading="loadingTrue" element-loading-background="rgba(255, 255, 255, 1)">
    <EmptyData :type="state" v-if="state!=1" style="margin-top: 10px;">
      当前数据已{{state==2?'下架':'删除'}}，点击 <a @click="handleBack">返回列表</a> 继续浏览吧~
    </EmptyData>
    <div v-if="state==1">
    <div class="team_title">
      <div class="team_title-left" style="display:flex">
        <div style="width:90px;height:90px;border:1px solid #E4E7ED;padding:11px 1px;box-sizing:border-box">
           <img :src="detail.avatarAddress?detail.avatarAddress:require('@/assets/public/shigongdui@2x.png')" v-if="detail.teamType==0" style="width:88px;height:68px">
           <img :src="detail.avatarAddress?detail.avatarAddress:require('@/assets/public/banzu@2x.png')" v-if="detail.teamType==1" style="width:88px;height:68px">
        </div>
        <div class="team_title-name" style="height:90px;box-sizing:border-box;margin-top:-3px">
          <p class="team_title-name-contact" >{{ detail.teamName }}</p>
          <p style="font-size: 14px;color: #333333;margin-top:10px">所在地区：
            <span>
               {{ detail.provinceName ? detail.provinceName : "" }}
                {{ detail.cityName ? `- ${detail.cityName}` : "" }}
                {{ detail.areaName ? `- ${detail.areaName}` : "" }}
                <!-- {{ detail.address ? `- ${detail.address}` : "" }} -->
            </span>
          </p>
        <div class="icon-group-link">
          <div class="link-item" @click.stop="userApply(detail)">
            <img src="@/assets/teamIcon/jiameng.png" alt />
            加盟
          </div>
          <div class="link-item" @click.stop="InvitedJoin(detail)">
            <img src="@/assets/teamIcon/yaoqing.png" alt />
            邀请
          </div>
          <div class="link-item" v-if="!isAttention" @click="clickAttention(true)" style="color:#969696;border-color:#E4E7ED ">
            <img src="@/assets/teamIcon/guanzhu.png" alt />
            关注
          </div>
          <div class="link-item" v-else @click="clickAttention(false)" style="color:#ff6600;border-color:#FF6600 ">
            <img src="@/assets/teamIcon/yiguanzhu.png" alt />
            已关注
          </div>
          <div
            class="link-item"
            @click.stop="inByLetDialogClick(detail.userNo, detail.teamName)"
          >
            <img src="@/assets/teamIcon/hanxun.png" alt />
            函询
          </div>
          <div class="link-item" @click="toChat(detail)">
            <img src="@/assets/teamIcon/jiaoliu.png" alt />
            交流
          </div>
          <div class="link-item" @click="toQueryPrice">
            <img src="@/assets/teamIcon/xunjia.png" alt="">
            询价
          </div>
          <inquiryDialog :detailNo="detail" :inquirer="inquirer" :isShowsDialog.sync="editshow" ref="memberEdit" v-if="editshow"></inquiryDialog>
         </div>
        </div>
      </div>

      <div class="team_title-right">
         <div style="width:200px;height:90px;padding:5px 0px;box-sizing:border-box">
           <img src="@/assets/teamIcon/shigongzhong.png" v-if="detail.buildStatus==0">
           <img src="@/assets/teamIcon/keyichugong.png" v-if="detail.buildStatus==1">
        </div>
      </div>
    </div>
    <!-- 加盟 -->
    <!-- <jJoin
      v-if="jShowJoin"
      :companyInfo="companyInfo"
      @closeJshowJoin="jShowJoin = false"
    ></jJoin> -->
    <!-- 邀请 -->
    <jInvitation
      v-if="jShow"
      :companyInfo="companyInfo"
      @closeJshow="jShow = false"
    ></jInvitation>
    <div class="team_content">
      <el-tabs v-model="activeName"  @tab-click="handleClick" >
<!--         <el-tab-pane label="工队信息" name="0" v-if="detail.teamType=='0'">
          <teammessage v-if="activeName == 0" :Detail="detail"></teammessage>
        </el-tab-pane>
         <el-tab-pane label="班组信息" name="0" v-if="detail.teamType=='1'" >
          <teammessage v-if="activeName == 0" :Detail="detail"></teammessage>
        </el-tab-pane>-->
        <el-tab-pane label="基本信息" name="1">
          <information v-if="activeName == 1" :Detail="detail"></information>
        </el-tab-pane>
        <el-tab-pane label="工队人员" name="2" v-if="detail.teamType=='0'">
          <teamRYtable v-if="activeName == 2"></teamRYtable>
        </el-tab-pane>
        <el-tab-pane label="班组人员" name="2" v-if="detail.teamType=='1'">
          <teamRYtable v-if="activeName == 2" style="border:none"></teamRYtable>
        </el-tab-pane>
        <el-tab-pane label="自有设备" name="3">
          <teamSBtable v-if="activeName == 3"></teamSBtable>
        </el-tab-pane>
        <el-tab-pane label="业绩公布" name="4">
          <teamYJtable v-if="activeName == 4"></teamYJtable>
        </el-tab-pane>
        <el-tab-pane label="专项资质" name="5">
          <teamZZtable v-if="activeName == 5"></teamZZtable>
        </el-tab-pane>
        <el-tab-pane label="团队风采" name="6">
          <team-album v-if="activeName == 6"></team-album>
        </el-tab-pane>
        <!-- <el-tab-pane label="施工风采" name="6">
          <team-video-album v-if="activeName == 6"></team-video-album>
        </el-tab-pane> -->
      </el-tabs>
    </div>
    <InByLetDialog
      ref="InBylet"
      :dialogVisible="inByLetDialogShow"
      :dialogType="1"
      @closeDialog="closeinDialog"
      @confirmDialog="confirminDialog"
    ></InByLetDialog>
      <!-- 推荐列表 -->
      <div class="recommendList">
        <div class="title">
          <div class="name">相关{{
              detail.teamType==0?'施工队':
                  detail.teamType==1?'班组工队':''
            }}推荐</div>
          <div class="more" @click="$router.replace('/teamList');reload()">
            查看更多
            <img src="@/assets/teamIcon/more.png" alt="">
          </div>
        </div>
        <div>
            <el-row style="padding: 0px 20px 20px;" :gutter="20" v-if="recommendedList.length">
              <el-col v-for="(item, index) in recommendedList" :span="12" :key="index">
                <card :item="item" :type="1"></card>
              </el-col>
            </el-row>
        </div>
        <BaseEmptyData v-if="!recommendedList.length && !loadingTrue"></BaseEmptyData>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/http"
import eventBus from "@/utils/event-bus"
import { mapState } from "vuex"
import { apiResignAll } from "@/api/apiResignAll"
import {checkDataStatus} from "@/utils/checkDataStatus"
import {api} from '@/api/apiRecommendedList'
import { apiHome } from "@/api/apiHome"
import { apiWorker } from "@/api/apiWorker"
export default {
  inject: ['reload'], // 引入App.vue 中的刷新页面的方法
  data() {
    return {
      state:1, // 数据状态：1 正常；2 下架； 3 删除
      detail: {},
      editshow: false,
      inquirer:'',
      isAttention: false,
      inByLetDialogShow: false,
      isRepeatSubmit: false,
      activeName: "1",
      showpNumber: false,
      // 邀请加盟
      jShow: false,
      companyInfo: {
        name: "",
        no: ""
      },
      // 申请加盟
      jShowJoin: false,
      loadingTrue: false,
      recommendedList:[]
    }
  },
  computed: {
    ...mapState({
      userNo: state => state.user.no,
      companyNo: state => state.user.companyNo,
      teamNo: state => state.user.teamNo,
      companyName: state => state.user.companyName,
      teamName: state => state.user.teamName,
      name: state => state.user.realName,
    })
  },
  components: {
    // 申请加盟
    jJoin: () => import("@/views/Home/components/jJoin"),
    // 邀请加盟
    jInvitation: () => import("@/views/Home/components/jInvitation"),
    InByLetDialog: () => import("@/components/public/InquiryLetterDialog"), // 函询弹框
    information: () => import("./components/information"), // 基本信息
    teamRYtable: () => import("./components/teamRYtable"), // 工队人员
    teamSBtable: () => import("./components/teamSBtable"), // 专业设备
    teamYJtable: () => import("./components/teamYJtable"), // 经营业绩
    teamZZtable: () => import("./components/teamZZtable"), // 专项资质
    teammessage: () => import("./components/Teammessage"),  //工队信息
    TeamAlbum: () => import("./components/TeamAlbum"), // 相册
    inquiryDialog: () => import("./components/inquiryDialog"), // 询价
    // TeamVideoAlbum: () => import("./components/TeamVideoAlbum") // 施工风采
    EmptyData:()=>import("@/components/public/UI/EmptyData"), // 数据被删除/下架显示的缺省图
    BaseEmptyData: () => import("@/components/public/BaseEmptyData"), // 暂无数据缺省图
    card:()=>import('@/components/card/cardTeam.vue'), // 施工队班组工队card
  },
  created() {
    if (this.$route.query) {
      this.getTeamDetail()
      this.userFocus(this.$route.query.teamNo)
    }
  },
  methods: {
    // 联系号码
    ShowPhone(phone) {
      if (phone && phone.length === 11) {
        const number = `${phone.slice(0, 3)}****${phone.slice(7, 11)}`
        return number
      }
    },
    //  查看联系方式
    ShowPhoneNumber() {
      if (this.$store.state.loginType) {
        this.showpNumber = true
      } else {
        this.loginIndex()
      }
    },
    loginIndex() {
      let data = {
        callBack: function() {
          this.$store.dispatch("setUser")
          this.pushThis()
        }.bind(this)
      }
      this.$_login(data)
    },
    handleClick(tab) {},
    /** @name 函询dialog关闭方法 */
    closeinDialog(val) {
      this.inByLetDialogShow = val
    },
    /** @name 函询提交方法 */
    async confirminDialog(obj) {
      obj.companyNo = this.detail.companyNo?this.detail.companyNo:'null'
      obj.markCreateNo = this.$route.query.userNo
      obj.markId=this.detail.no
      obj.markName=this.detail.teamName
      obj.title=`【${this.detail.teamTypeName}】`+this.detail.teamName
      obj.markType=1
      let data = { ...obj }
      let res = await apiResignAll.getaddEnquire(data)
      if (res.data.code === 200) {
        this.$message.success(res.data.msg)
        this.inByLetDialogShow = false
        // this.$refs.InBylet.clearForm()
      } else {
        this.$message.error(res.data.msg)
      }
    },
    /** @name 获取店铺信息 */
    async getTeamDetail() {
      this.loadingTrue = true
      let res = await apiResignAll.TeamInfoDetails(this.$route.query.teamNo)
      if (res.data.code === 200) {
        this.detail = res.data.data
        if (this.detail.idNumber&&(this.detail.idNumber.includes("X") || this.detail.idNumber.includes("x"))){
          this.detail.idNumber = this.detail.idNumber.substring(0,2)+"**************"+this.detail.idNumber.substring(16,17)+"X";
        }else {
          this.detail.idNumber = this.detail.idNumber?this.detail.idNumber.replace(/^(\d{2})\d+(\d{2})$/, "\$1**************\$2"):""
        }
        //处理工队名称隐藏
        let arr=this.detail.teamName.split('-')
        if(arr[0].length > 2){
          arr[0]=arr[0].substr(0, 1) + '*'+ arr[0].substr(-1)
        }else{
          arr[0]=arr[0].substr(0, 1) + '*'
        }
        this.detail.teamName=arr.join('-')
        // this.$store.commit("SET_INDIVIDUALTEAMINFO", this.detail);
        // this.$store.commit("SET_TEAMNAME", this.detail.teamName);
      }
      this.loadingTrue = false
      this.getRecommendedList()
    },
    /** @name 函询按钮点击方法 */
    async inByLetDialogClick() {
      const rules = {}
      if(this.permissionTips(rules)) return
      if(!await this.validData()){
        return
      }
        if (this.detail.userNo === this.userNo) {
          this.$message.error("不能给自己发送函询！")
          return
        }
        this.inByLetDialogShow = true
    },
    // 交流
    async toChat(item) {
      const rules = {
        realName:false
      }
      if(this.permissionTips(rules)) return

      if(!await this.validData()){
        return
      }
        if (item.userNo === this.userNo || item.user_no === this.userNo) {
          this.$message.error("不能和自己交流！")
          return
        }
        if (item.companyNo === this.companyNo||(item.teamNo&&item.teamNo === this.teamNo)) {
          this.$message.error("不能对同组织架构下的人员进行交流！")
          return
        }
        if (item.imId) {
          axios
            .get(
              process.env.VUE_APP_COMPANY +
                "/v1/organization/getUser/" +
                item.imId
            )
            .then(res => {
              if (res.data.code === 200) {
                if (res.data.data.imAccount) {
                  eventBus.$emit("sendImMessage", res.data.data.imAccount)
                } else {
                  this.$message.err("未找到客服人员")
                }
              } else {
                this.$message.error(res.data.msg)
              }
            })
        }else if(!item.imId&&item.userNo){
           let {data} = await apiWorker.getfindUserByNo(item.userNo)
           if (data.code === 200) {
                if (data.data.imAccount) {
                  eventBus.$emit("sendImMessage", data.data.imAccount)
                } 
              } else {
                this.$message.error(data.msg)
              }
        }else {
          if(item.employmentType==1)this.$message.error("未设置客服人员，无法交流！")
        }
    },
    /** @name 申请 */
    async userApply(detail) {
      const rules = {}
      if(this.permissionTips(rules)) return
      if(!await this.validData()){
        return
      }
      const { data: res } = await apiHome.getIdentifiers();
			const arr = res.result.identifiers
			const ApplyMemberC = arr.some(i=>i==='ApplyMemberC')//申请权限
      let isCompany = this.$store.state.user.type === 1//企业
      let isPersonal = this.$store.state.user.type === 0//个人
      let isRelevance =(this.$store.state.user.type === 1||this.$store.state.user.type === 0)&&this.$store.state.user.relevance
      if ((isCompany || isPersonal) && isRelevance) {
        if(ApplyMemberC){
          if(detail.companyNo&&detail.companyNo!=this.$store.state.user.companyNo){
            const query=`${process.env.VUE_APP_VIP}/joinInfo/?no=${detail.companyNo}&type=1&personal=0&isApproval=0`
            window.open(query,'_blank')
          }else if(isPersonal&&detail.isCompany==0&&detail.userNo==this.$store.state.user.no){
            this.$message.error("不能申请加盟自己")
          }else if(!detail.companyNo&&detail.isCompany!==2){
            this.$message.error("该工队暂未认证企业,暂时无法加盟!")
          }else if(detail.companyNo==this.$store.state.user.companyNo){
            this.$message.error("无法加盟自己的企业!")
          }else if(detail.isCompany==2){
            this.$message.error("发布方为团队身份，暂无申请加盟权限")
          }
        }else{
          this.$message.error("您没有权限，请联系管理员开通!")
        }
      } else{
        this.$message.error("请切换至企业/个人身份才可以申请加盟")
      }
    },
    /** @name 邀请 */
    async InvitedJoin(detail) {
      const rules = {}
      if(this.permissionTips(rules)) return
      if(!await this.validData()){
        return
      }
      const { data: res } = await apiHome.getIdentifiers();
			const arr = res.result.identifiers
			const InviteJoinListC = arr.some(i=>i==='InviteJoinListC')//邀请权限
      let isCompany = this.$store.state.user.type === 1//企业
      let isPersonal = this.$store.state.user.type === 0//个人
      let isRelevance =(this.$store.state.user.type === 1||this.$store.state.user.type === 0)&&this.$store.state.user.relevance
      if ((isCompany || isPersonal) && isRelevance) {
        if(InviteJoinListC){
          if(detail.companyNo&&detail.companyNo!=this.$store.state.user.companyNo){
            const query=`${process.env.VUE_APP_VIP}/joinInfo/?no=${detail.companyNo}&type=0&personal=0&isApproval=0`
            window.open(query,'_blank')
          }else if(isPersonal&&detail.isCompany==0&&detail.userNo==this.$store.state.user.no){
            this.$message.error("不能邀请加盟自己")
          }else if(!detail.companyNo&&detail.isCompany!==2){
            this.$message.error("该工队暂未认证企业,暂时无法加盟!")
          }else if(detail.companyNo==this.$store.state.user.companyNo){
            this.$message.error("无法邀请自己的企业!")
          }else if(detail.isCompany==2){
            this.$message.error("发布方为团队身份，暂无邀请加盟权限")
          }
        }else{
          this.$message.error("您没有权限，请联系管理员开通!")
        }
      } else{
        this.$message.error("请切换至企业/个人身份才可以申请邀请")
      }
    },
    /**
     * @name 点击关注
     * @type 工队1 工程2 工人3 */
    async clickAttention(state) {
      const rules = {}
      if(this.permissionTips(rules)) return

      if(!await this.validData()){
        return
      }
        let isAttention = state
        let no = this.$route.query.teamNo
        let type = 1
        // let isAttention = state;
        if (this.isRepeatSubmit) return this.isRepeatSubmit = true;
        if (this.detail.userNo === this.userNo) return this.$message.error("不能关注自己")
        apiResignAll
          .addAttention(no, type, isAttention)
          .then(res => {
            if (res.data.code === 200) {
              this.isAttention = state
              if (state) {
                this.$message.success("关注成功")
              } else {
                this.$message.success("取消关注成功")
              }
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .finally(() => {
            this.isRepeatSubmit = false
          })
    },
    /** @name 获取是否关注 */
    userFocus(no) {
      let type = 1
      // if (this.$store.state.loginType) {
        apiResignAll.userFocus(no, type).then(res => {
          if (res.data.code === 200) {
            this.isAttention = res.data.data
          }
        })
      // }
    },
    // 点击“询价”
    async toQueryPrice(){
      const rules = {}
      if(this.permissionTips(rules)) return
      if(!await this.validData()){
        return
      }
      if(this.detail.userNo===this.userNo){
        this.$message.error('无法询价自己的工队')
        return
      }
      if(this.detail.companyNo===this.companyNo||(this.detail.teamNo&&this.detail.teamNo===this.teamNo)){
        this.$message.error('不能对同组织结构下的工队进行询价')
        return
      }
      let res = await apiResignAll.checkQueryPrice(this.detail.no)
      if(res.data.data){
        this.$message.error('该工队已经询过价，请勿重复询价')
        return
      }
      this.inquirer=this.companyName?this.companyName+'-'+this.name:this.teamName?this.teamName+'-'+this.name:this.name
      this.editshow=true
    },
    /**
     * 调用工具方法检测数据有效性
     */
    async validData(){
      const state = await checkDataStatus(1,this.$route.query.teamNo)
      if(!state){
        this.$message.error('系统异常，请稍后再试')
        return false
      }
      this.state = state
      return this.state==1
    },
    handleBack(){
      const referrer = document.referrer
      if(referrer.includes('ConstructionTeamDetail') || referrer.includes('popularityTeamDetail')){
        this.$router.replace('/teamList')
      } else {
        window.location.href = referrer
      }
    },
    /**
     * 获取推荐列表
     */
    async getRecommendedList(){
      this.loadingTrue = true
      const {firstCategoryNo, no:teamNo, provinceNo, teamType} = this.detail
      const params = {
        firstCategoryNo, // 一级分类编号
        provinceNo, // 省编号
        teamType, // 工队类型：0 施工队 1 班组 2承包商
        teamNo // 当前工队no
      }
      const res = await api.getTeamRecommend(params)
      if(res.data.code===200){
        this.recommendedList = res.data.data.slice(0,6)
      }else {
        this.$message.error('系统异常，请稍后再试')
        this.recommendedList = []
      }
      this.loadingTrue = false
    },
    getList(){
      this.getRecommendedList()
    }
  },
  provide(){
    return {
      cardListCom:this
    }
  }
}
</script>

<style lang="scss" scoped>
.ConstructionTeamDetail_page {
  width: 1200px;
  margin: 0 auto;
  .team_title {
    background-color: #fff;
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    padding:15px 20px 20px;
    .team_title-left{
      img{
        width: 92px;
        height: 92px;
      }
      .team_title-name{
        margin-left: 10px;
        width: 675px;
        .team_title-name-contact{
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #000000;
          line-height: 24px;
          // margin-top: -8px;
        }
      }
      .icon-group-link {
      display: flex;
      align-items: center;
      margin-top: 10px;
      height: 34px;
      .link-item {
          width: 82px;
          height: 34px;
          border-radius: 4px;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          border: 1px solid #B79255;
          background-color: #ffffff;
          display: flex;
          align-items: center;
          cursor: pointer;
          font-size: 14px;
          color: #B79255;
          margin-right: 15px;
          // padding: 0 15px;
          justify-content: center;
        img {
          width: 20px;
          height: 20px;
          margin-right: 5px;
        }
        &:hover {
          opacity: 0.9;
        }
        span {
          a {
            color: #333333;
            text-decoration: none;
            &:visited,
            &:hover {
              color: #B79255;
              text-decoration: none;
            }
          }
        }
      }
    }
    }
   .team_title-right{
      //  width: 400px;
  //     .icon-group-link {
  //     // margin-top: 20px;
  //     // margin-bottom: 20px;
      display: flex;
      // justify-content: center;
      align-items: center;
  //     flex-wrap: wrap;
  //     margin-top: 6px;
      height: 90px;
  //     border-left: 1px solid #E4E7ED;
  //     .link-item {
  //       display: flex;
  //       align-items: center;
  //       cursor: pointer;
  //       border: 1px solid #0286df;
  //       padding: 5px 10px;
  //       border-radius: 4px;
  //       font-size: 13px;
  //       color: #0286df;
  //       margin-right: 8px;
  //       background-color: #fff;
  //       width: 60px;
  //       margin-bottom: 8px;
  //       img {
  //         width: 20px;
  //         height: 20px;
  //         margin-right: 10px;
  //       }
  //       &:hover {
  //         opacity: 0.9;
  //       }
  //       span {
  //         a {
  //           color: #333333;
  //           text-decoration: none;
  //           &:visited,
  //           &:hover {
  //             color: #0286df;
  //             text-decoration: none;
  //           }
  //         }
  //       }
  //     }
  //   }
   }
    // .title {
    //   height: 70px;
    //   line-height: 70px;
    //   border-bottom: 1px dashed #e4e7ed;
    //   font-size: 18px;
    //   font-weight: bold;
    //   text-align: center;
    // }
    // .team_info {
    //   padding: 45px;
    //   padding-bottom: 0;
    //   .single_hide {
    //     // 单行隐藏
    //     overflow: hidden;
    //     text-overflow: ellipsis;
    //     white-space: nowrap;
    //   }
    //   .color3 {
    //     color: #333333;
    //   }
    //   .item_tag {
    //     font-weight: bold;
    //   }
    //   .item_text {
    //     font-size: 14px;
    //     font-weight: 400;
    //     color: #666666;
    //     display: flex;
    //     align-items: center;
    //     padding: 10px 0;
    //     .color3 {
    //       color: #333333;
    //     }
    //     .item_icon {
    //       width: 24px;
    //       height: 24px;
    //       padding: 0 20px;
    //     }
    //   }
    //   .top-text {
    //     display: flex;
    //     justify-content: space-between;
    //     font-size: 12px;
    //     color: #969696;
    //     .tips {
    //       padding-bottom: 20px;
    //       padding-left: 20px;
    //     }
    //     img {
    //       margin-right: 5px;
    //     }
    //     .num {
    //       color: #333;
    //       padding: 0 5px;
    //     }
    //     .fx {
    //       display: flex;
    //     }
    //     .ls {
    //       display: flex;
    //       margin-top: 10px;
    //       .lianxi {
    //         margin: 0 10px;
    //       }
    //     }
    //   }
    // }
    // .icon-group-link {
    //   margin-top: 20px;
    //   margin-bottom: 20px;
    //   display: flex;
    //   justify-content: center;
    //   align-items: center;
    //   .guanzhu {
    //     font-size: 14px;
    //     color: #ff7878;
    //     display: flex;
    //     align-items: center;
    //     margin-left: 10px;
    //     cursor: pointer;
    //     img {
    //       width: 19px;
    //       height: 17px;
    //       margin-right: 10px;
    //     }
    //   }
    //   .link-item {
    //     display: flex;
    //     align-items: center;
    //     cursor: pointer;
    //     border: 1px solid #0286df;
    //     padding: 11px 20px;
    //     border-radius: 4px;
    //     font-size: 13px;
    //     color: #0286df;
    //     margin-right: 10px;
    //     background-color: #fff;
    //     img {
    //       width: 19px;
    //       height: 14px;
    //       margin-right: 10px;
    //     }

    //     &:hover {
    //       opacity: 0.9;
    //     }

    //     span {
    //       a {
    //         color: #333333;
    //         text-decoration: none;

    //         &:visited,
    //         &:hover {
    //           color: #0286df;
    //           text-decoration: none;
    //         }
    //       }
    //     }
    //   }
    // }
  }
  .team_content {
    // margin-top: 10px;
    // border: 1px solid #e4e7ed;
    // background-color: #fff;
    /deep/ .el-tabs__item{
      color: #FFFFFF ;
      font-size: 18px  ;
      font-family: Microsoft YaHei;
      font-weight: 400;
      width: 110px;
      text-align: center;
      padding: 0px;
      height: 42px;

    }
    // /deep/ .el-tabs__nav{
    //   padding-left: 20px;
    // }
    /deep/ .el-tabs__active-bar{
      height: 0px;
    }
    /deep/ .el-tabs__item.is-active {
      color: #FFFFFF;
      background: hsla(0,0%,100%,.2);
    }
    /deep/ .el-tabs__item:hover {
      color:#FFFFFF;
    }
    /deep/ .el-tabs {
      .el-tabs__header {
        margin: 0;
        background: #B79255;
        color: #FFFFFF;


      }
      .el-tabs__content {
        // padding: 20px;
        margin-top: 10px;
        background-color: #fff;
        border: 1px solid #e4e7ed;
      }
    }
  }
}
/deep/  .el-table::before{
 background-color: unset !important;
}

/deep/ .el-tabs__nav-wrap::after{
  background-color: unset !important;

}
/deep/.el-tabs__nav {
   background: #b79255;
}
.recommendList{
  margin-top: 10px;
  background-color: #FFFFFF;
  border: 1px solid #E4E7ED;
  .title {
    font-weight: normal !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px 0;
    border-bottom: 1px solid #E4E7ED;
    .name{
      color: #B79255;
      font-size: 16px;
      height: 15px;
      padding-left: 10px;
      border-left: 3px solid #B79255;
      line-height: 15px;
      margin: 10px 0px;
    }
    .more {
      cursor: pointer;
      font-size: 14px;
      color: #666666;
      display: flex;
      align-items: center;
      line-height: 1;
      img {
        margin-left: 5px;
        width: 16px;
        height: 16px;
      }
    }
  }
  /deep/ .empty-data .nodata .message{
    line-height: 1;
  }
}
</style>
